import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.7_@babel+core@7.28.4_@opentelemetry+api@1.9.0_react-dom@19.1.1_react@19.1.1__react@19.1.1/node_modules/next/dist/client/image-component.js");
